module.exports = __webpack_public_path__ + "img/character_details.1cee11a5.png";